import React from 'react';
import PropTypes from 'prop-types';

import { BottomSheet } from '@xingternal/bottom-sheet';

import styles from './SecondaryList.css';
import { SecondaryItem } from './SecondaryItem';

const SecondaryList = ({ show, onOutsideClick, navigationItems }) => {
  // Iterate over sections and add styles.separator for visually grouping

  return (
    <BottomSheet
      key="sheet"
      dimmerTitle="close"
      onOutsideClick={onOutsideClick}
      show={show}
    >
      <ul className={styles.more}>
        {navigationItems.map((item) => (
          <SecondaryItem item={item} key={item.key} />
        ))}
      </ul>
    </BottomSheet>
  );
};

SecondaryList.displaName = 'SecondaryList';

SecondaryList.defaultProps = { show: false };
SecondaryList.propTypes = {
  navigationItems: PropTypes.array.isRequired,
  onOutsideClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export { SecondaryList };
